import { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton, Typography } from "@material-ui/core";
import ArchiveOutlinedIcon from "@material-ui/icons/ArchiveOutlined";
import History from "@material-ui/icons/HistoryOutlined";
import clsx from "clsx";
import { useHistory } from "react-router";

import { useGetVmsSearchRightsQuery } from "@/api/elasticSearch/vmsSearchApi";
import * as FullStory from "@/utilities/hooks/fullstory";
import { handleHighlight } from "@/utilities/jsx";
import { SearchResult, ArchiveCabinetSearchData, SearchIndex } from "@/utilities/types/search";

import { resultStyles } from "./ResultStyles";


interface ArchiveCabinetResultProps {
    result: SearchResult<ArchiveCabinetSearchData>,
    onSelect: (id: number) => void;
}

const ArchiveCabinetResult = ({ result, onSelect }: ArchiveCabinetResultProps) => {
    const { data: searchRightsData } = useGetVmsSearchRightsQuery({ indices: [SearchIndex.LiveUnits, SearchIndex.ArchiveCabinets, SearchIndex.Clients] });
    const unit = result.source;

    const classes = resultStyles();
    const history = useHistory();

    const name = result.highlight?.["name"] ?? unit.name;
    const clientName = result.highlight?.["client_name"] ?? unit.client_name;
    const locationName = result.highlight?.["location_name"] ?? unit.location_name;

    const navigateToHistory = () => {
        history.push(`/archive-cabinet/${unit.id}/history`);
    };

    return (
        <ListItem
            data-testid={"archive-cabinet-result"}
            className={clsx(classes.item, FullStory.names.classes.searchResults.viewUnit)}
            onClick={() => onSelect(unit.id)}
            alignItems="flex-start"
            dense
            button
        >
            <ListItemIcon>
                <ArchiveOutlinedIcon color="action" />
            </ListItemIcon>
            <ListItemText
                primary={<Typography className={classes.title} variant="body1" component={"div"}>{handleHighlight(locationName)}</Typography>}
                disableTypography
                secondary={
                    <div className={classes.subheader}>
                        <Typography noWrap variant="body2" component={"div"}>
                            {searchRightsData?.data.is_multi_client &&
                                <>
                                    {handleHighlight(clientName)}
                                    <span> | </span>
                                </>
                            }
                            <span>(Archived) {handleHighlight(name)}</span>
                        </Typography>
                    </div>
                }
            />
            <ListItemSecondaryAction>
                <IconButton
                    onClick={navigateToHistory}
                    className={FullStory.names.classes.searchResults.viewHistory}
                >
                    <History />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
};

export default ArchiveCabinetResult;
